import { ReactElement, FC } from "react";
import { Icon } from "capitalrx-components-2.0/lib/general";
import { Search } from "../Search";
import { SearchProps } from "../Search/Search.props";
import { DrugProps } from "@/api/interfaces";

import styles from "./Search.module.scss";

const FindBestPriceSearch: FC<SearchProps<DrugProps>> = (props) => {
  const {
    autoFocus,
    getSuggestions,
    suggestions,
    onSuggestionClick,
    onEnterSearch,
    onChange,
    loading,
    inputClassName,
    searchBarButtonClass,
    searchBarMagnifyingGlassClass,
    searchBarWrapperClassName,
  } = props;

  const buttonContent = (): ReactElement => (
    <>
      <span className={styles.ButtonDesktopContent}>Find Best Price</span>
      <span className={styles.ButtonMobileContent}>
        <Icon name="search" size="regular" aria-hidden="true" />
      </span>
    </>
  );

  return (
    <Search
      name="find_best_price_tool_search"
      testId="find-best-price-tool-search"
      placeholder="Search for your drug"
      displaySearchButton
      buttonContent={buttonContent()}
      searchBarButtonSize="medium"
      searchBarWrapperClassName={styles.FindBestPriceToolWrapper}
      containerClassName={`${styles.FindBestPriceToolContainer} ${searchBarWrapperClassName}`}
      inputClassName={`${styles.FindBestPriceToolInput} ${inputClassName}`}
      searchBarButtonClass={`${styles.SearchBarButton} ${searchBarButtonClass}`}
      autoCompleteClassName={styles.SearchAutoComplete}
      searchBarMagnifyingGlassClass={`${styles.searchBarMagnifyingGlass} ${searchBarMagnifyingGlassClass}`}
      getSuggestions={getSuggestions}
      suggestions={suggestions}
      suggestionTitle={null}
      onSuggestionClick={onSuggestionClick}
      onEnterSearch={onEnterSearch}
      onChange={onChange}
      loading={loading}
      autoFocus={autoFocus}
      buttonTestId="find-best-price-search-button"
    />
  );
};

export default FindBestPriceSearch;
